var React = require('react');

function ArrowToBottom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M360 480H24a23.94 23.94 0 0 1-24-23.88V440a23.94 23.94 0 0 1 23.88-24H360a23.94 23.94 0 0 1 24 23.88V456a23.94 23.94 0 0 1-23.88 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M327.87 190.52l17.06 17a23.86 23.86 0 0 1 .17 33.74l-.17.17L209 377a24 24 0 0 1-33.94.06L175 377 39.07 241.43a23.86 23.86 0 0 1-.17-33.74l.17-.17 17.06-17a24 24 0 0 1 33.94-.06l.06.06 65.81 65.61V56a24 24 0 0 1 24-24h24.14a24 24 0 0 1 24.07 23.93v200.2L294 190.52a23.91 23.91 0 0 1 33.8-.07z","className":"fa-primary","key":2})]);
}

ArrowToBottom.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowToBottom;

ArrowToBottom.default = ArrowToBottom;
